import { useSetAtom } from 'jotai';
import { fullscreenLoaderAtom, IFullscreenLoaderAtom } from '../atom';

export function useFullscreenLoader() {
  const setLoader = useSetAtom(fullscreenLoaderAtom);

  const showLoader = (config: IFullscreenLoaderAtom) => {
    setLoader(config);
  };

  const hideLoader = () => {
    setLoader(false);
  };

  return { showLoader, hideLoader };
}
